/* js/tabs.js */

jQuery( document ).ready(function( $ ) {



});